import React from 'react'
import './Loader.css'
import CustomLoader from 'react-spinners/PuffLoader';

function Loader() {
    return (
        <div className="loading-container">
            <CustomLoader color="#212529" size={60} speedMultiplier={1} />
        </div>
    )
}

export default Loader